<template>    
    <div style="height:500px">
        <canvas ref="chart"></canvas>    
    </div>
</template>

<script>
    import {Chart} from 'chart.js';
    export default{

        props:[
            'isin',
            'values',
        ],

        
        mounted(){
            var ctx = this.$refs.chart.getContext('2d');
            
            var labels  = [];
            var prices = [];
            this.values.forEach(value=>{
                labels.push(value.date);
                prices.push(value.price);
            });

            var myChart = new Chart(ctx, {
                type: 'line',
                data: {    
                    labels: labels,    
                    datasets: [
                        {
                            label: this.isin,
                            backgroundColor: '#f87979',
                            borderColor: '#f87979',
                            data: prices,
                            fill:false,
                            cubicInterpolationMode:'monotone',
                        }
                    ]
                },                
                options: {                    
                    maintainAspectRatio: false,                    
                }
            });
        }
    }
</script>